import { FormArray, FormGroup } from '@angular/forms';
import { LevelDesignerComponent } from '../../level-designer/level-designer.component';
import { SelectInput, SelectOption } from './select-input';
import { PropertyEditor } from '../property-editor';

export class FormControlSelectInput extends SelectInput {
    protected formArrayName: string;

    constructor(
        ctx: CanvasRenderingContext2D,
        x: number,
        y: number,
        width: number,
        height: number,
        value: string,
        isActive: boolean,
        levelDesigner: LevelDesignerComponent,
        propertyEditor: PropertyEditor,
        formArrayName: string,
        idProperty: string,
        labelProperty: string
    ) {
        // Initialize with empty options, we'll load them later
        super(ctx, x, y, width, height, value, isActive, [], levelDesigner, propertyEditor);
        this.formArrayName = formArrayName;
        this.idProperty = idProperty;
        this.labelProperty = labelProperty;
        this.loadOptions();
    }

    private loadOptions(): void {
        this.options = [];
        
        // Get the form array from the level designer
        if (this.levelDesigner && this.levelDesigner.levelData) {
            const formArray = this.levelDesigner.levelData.get(this.formArrayName) as FormArray;
            
            if (formArray) {
                // Convert form controls to options
                formArray.controls.forEach(control => {
                    const formGroup = control as FormGroup;
                    const id = formGroup.get(this.idProperty)?.value;
                    const label = formGroup.get(this.labelProperty)?.value;
                    // If label is missing, use id as the label
                    const displayLabel = label || id;
                    if (id !== undefined) {
                        this.options.push({
                            value: id,
                            label: displayLabel
                        });
                        if(id == this.value) {
                            this.displayValue = displayLabel;
                            this.searchText = this.displayValue;
                        }
                    }
                });
            }
        }
    }

    // Override handleClick to reload options before showing dropdown
    override handleClick(x: number, y: number): boolean {
        // Reload options each time to ensure we have the latest data
        this.loadOptions();
        return super.handleClick(x, y);
    }

    // Override handleKeyEvent to reload options
    override handleKeyEvent(event: KeyboardEvent): boolean {
        return super.handleKeyEvent(event);
    }

    // Override focus to reload options
    override focus(): void {
        this.loadOptions();
        super.focus();
    }

    
} 
